import React from "react";
import { Link } from "react-router-dom";
import Event from "../../common/Event";

const PopularEventArea = ({ events = [] }) => (
  <section className="hn-section">
    <h2 className="hn-section-title">Popular Events</h2>
    <p className="hn-section-subtitle">Discover what&apos;s happening near you</p>
    {events.length > 0 ? (
      <div className="hn-cards">
        {events.map((event, index) => (
          <Event key={event.id} eventData={event} />
        ))}
      </div>
    ) : (
      <p style={{ color: "var(--hn-gray5)", textAlign: "center" }}>
        No events at the moment. <Link to={`${process.env.PUBLIC_URL || ""}/events`}>Browse events</Link>.
      </p>
    )}
  </section>
);

export default PopularEventArea;
